// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__vWx9G","image":"logo_image__1ovOa","imageMobile":"logo_imageMobile__356SU","text":"logo_text__12PyK","textMobile":"logo_textMobile__1qaUo"};